export const tourName = "Tour Name is Required"
export const tourDescription = "Tour Description is Required"
export const tourCity = "Tour City is Required"
export const tourCountry = "Tour Country is Required"
export const latitude = "Tour latitude is Required"
export const longitude = "Tour longitude is Required"
export const scenename = "Scene Name is Required"
export const scenedescription = "Scene description is Required"
export const hotspotname = "Hotspot name is required"
export const hotspotdescription = "Hotspot description is required"
export const posterurl = "Tour poster is required"
export const sceneurl = "Scene Pano image is required"
export const hotspotsceneIndex = "Scene Selection is required"
export const scene = "Atleast one scene is reqired"